const ItemTitle = ({ title }: { title: string }) => {
  return <span className="text-specialGray-1 text-sm sm:text-base truncate font-medium">{`${title}`}</span>;
};

export default ItemTitle;
